module.exports = __webpack_public_path__ + "assets/79e01ddd7eebce43c22dc3318cdd711f.mp3";